import MapService from "../../includes/mapService";

// Mapbox-Zugangsdaten
const mapboxAccessToken =
  typeof window !== "undefined" ? window.mapbox_key : null;

const mapService = new MapService(mapboxAccessToken, "map");

function initMap() {
  const mapElement = document.getElementById("map");
  const mapData = document.getElementById("map-data");

  if (!mapElement || !mapData) return;

  if (mapElement.classList.contains("mapboxgl-map")) {
    mapService.destroy();
  }

  // Map-Element sichtbar machen und Größe setzen
  mapElement.style.display = "block";
  if (!mapElement.style.height && !mapElement.className.includes("h-[")) {
    mapElement.style.height = "60vh";
  }
  if (!mapElement.style.width) {
    mapElement.style.width = "100%";
  }

  // Markerdaten extrahieren
  let markersData = [];
  try {
    markersData = JSON.parse(mapData.dataset.items);
  } catch (e) {
    markersData = [mapData.dataset.items];
  }
  if (mapData.dataset.mapTargets) {
    const mapTargets = JSON.parse(mapData.dataset.mapTargets);
    markersData = markersData.map((marker) => ({
      ...marker,
      url: mapTargets[marker.id]?.url ?? marker.url,
      map_portal: mapTargets[marker.id]?.portal ?? null,
    }));
  }
  const showDirection = mapData.hasAttribute("data-show-direction");

  mapService.init(markersData, showDirection);
  setTimeout(() => mapService.resize(), 100);
}

document.addEventListener("DOMContentLoaded", () => {
  const mapElement = document.getElementById("map");
  const mapData = document.getElementById("map-data");
  const modal = document.getElementById("rentalMapModal");

  // Auto-init for inline maps (maps not inside a modal or explicitly marked inline)
  if (
    mapElement &&
    mapData &&
    (!modal ||
      mapElement.hasAttribute("data-map-inline") ||
      mapData.hasAttribute("data-map-inline"))
  ) {
    initMap();
  }

  document.querySelectorAll("*[data-map=init]").forEach((button) => {
    button.addEventListener("click", () => {
      initMap();
    });
  });

  window.addEventListener("resize", () => {
    mapService.resize();
  });
});
